import React, { useState } from 'react';
import { DatabaseEngine } from '../../../types/database.type';

interface EngineCardProps {
  engine: DatabaseEngine;
  selected: boolean;
  onClick: () => void;
}

const EngineCard: React.FC<EngineCardProps> = ({ engine, selected, onClick }) => {
  const [imageError, setImageError] = useState(false);
  const useImage = engine.image && !imageError;

  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-3 p-4 border-2 rounded-lg transition-all ${
        selected ? 'border-black dark:border-white bg-gray-50 dark:bg-gray-700' : 'border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600'
      }`}
    >
      <div
        className={`w-12 h-12 rounded-lg flex items-center justify-center text-2xl overflow-hidden ${
          useImage ? 'bg-transparent' : `bg-gradient-to-br ${engine.color}`
        }`}
      >
        {useImage ? (
          <img
            src={engine.image}
            alt={engine.name}
            className="w-10 h-10 object-contain"
            onError={() => setImageError(true)}
          />
        ) : (
          engine.icon
        )}
      </div>
      <div className="text-left">
        <p className="font-semibold text-gray-900 dark:text-white">{engine.name}</p>
        <p className="text-xs text-gray-500">{engine.description}</p>
      </div>
    </button>
  );
};

export default EngineCard;